// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"0582df0a","513":"5dbb0da4","703":"c222d9d2","787":"248dd327"}[chunkId] + ".chunk.js";
};